export function balanceResultValidate(balance_result){
    var result = true;

    if (balance_result)
    
    
    return result;
}